module.exports = __webpack_public_path__ + "img/w3_circle_trash_delete_light.66979d90.png";